module.exports = __webpack_public_path__ + "static/media/Resalat.2ba7e3b5.svg";